import * as v from "valibot";
import { rpcContract } from "../rpc";

export const getRecordingStatusRpcContract = rpcContract({
  name: "get-recording-status",
  paramsSchema: v.object({
    liveEventId: v.string(),
  }),
  resultSchema: v.object({
    status: v.nullable(v.string()),
    recordingUrl: v.nullable(v.string()),
  }),
});

export type GetRecordingStatusParams = v.InferOutput<(typeof getRecordingStatusRpcContract)["paramsSchema"]>;
export type GetRecordingStatusResult = v.InferOutput<(typeof getRecordingStatusRpcContract)["resultSchema"]>;
